import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';

// @mui

import { Box } from '@mui/material';

// ----------------------------------------------------------------------

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 254 202"
        id="vector">
        <path
          id="path"
          d="M 254 62.969 C 254 66.229 253.722 69.38 253.202 72.497 L 253.202 72.535 C 251.603 82.322 247.491 91.339 241.501 99.072 C 241.501 99.072 240.024 101.054 239.145 102.008 C 236.551 105.013 126.959 202 126.98 202 C 127 202 13.935 101.419 10.306 96.067 C 7.229 91.598 4.791 86.757 3.118 81.623 C 2.037 78.619 1.281 75.543 0.757 72.351 C 0.241 69.309 0 66.158 0 62.969 C 0 57.028 0.88 51.316 2.557 45.885 L 2.557 45.852 C 5.871 34.964 12.339 25.286 20.963 17.662 C 23.361 15.537 25.914 13.561 28.63 11.762 C 35.459 7.252 43.248 3.879 51.672 1.938 C 54.385 1.314 57.142 0.804 59.977 0.511 C 62.813 0.18 65.689 0 68.602 0 C 73.953 0 79.182 0.545 84.173 1.682 C 86.849 2.197 89.488 2.929 92 3.804 C 100.947 6.775 109.052 11.469 115.802 17.403 C 116.76 18.211 117.676 19.056 118.474 19.934 C 121.628 22.943 126.783 29.797 126.783 29.797 L 137.163 18.323 C 139.916 15.796 142.911 13.486 146.106 11.436 C 150.459 8.611 155.172 6.264 160.164 4.428 C 162.68 3.515 165.233 2.708 167.871 2.084 C 173.46 0.729 179.327 0 185.398 0 C 187.677 0 189.952 0.109 192.19 0.33 C 195.103 0.545 197.979 0.988 200.773 1.607 C 209.078 3.331 216.827 6.445 223.692 10.7 C 226.286 12.314 228.802 14.106 231.122 16.014 C 239.623 23.018 246.214 31.922 250.085 41.998 L 250.085 42.04 C 250.805 43.869 251.443 45.668 251.926 47.575 C 252.683 50.216 253.202 52.961 253.562 55.744 L 253.562 55.823 C 253.599 56.187 254 60.915 254 62.969"
          fill="#42a5f5"
          stroke="#00000000"
          strokeWidth="1"
          fillRule="evenodd" />
        <path
          id="path_1"
          d="M 169 52 C 165.14 52 162 55.359 162 59.5 L 162 119.498 C 162 123.64 165.14 127 169 127 C 172.864 127 176 123.64 176 119.498 L 176 59.5 C 176 55.359 172.864 52 169 52 Z M 139 68 C 135.138 68 132 71.301 132 75.376 L 132 119.626 C 132 123.699 135.138 127 139 127 C 142.86 127 146 123.699 146 119.626 L 146 75.376 C 146 71.301 142.86 68 139 68 Z M 109 82 C 105.136 82 102 85.357 102 89.497 L 102 119.501 C 102 123.643 105.136 127 109 127 C 112.862 127 116 123.643 116 119.501 L 116 89.497 C 116 85.357 112.862 82 109 82 Z M 79 96 C 75.137 96 72 99.472 72 103.75 L 72 119.249 C 72 123.528 75.137 127 79 127 C 82.863 127 86 123.528 86 119.249 L 86 103.75 C 86 99.472 82.863 96 79 96 L 79 96 Z"
          fill="#ffffff"
          stroke="#00000000"
          strokeWidth="1"
          fillRule="evenodd" />
      </svg>

    </Box>
  );

  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="/">{logo}</RouterLink>;
}
